import {SelectField} from './select-field';
import {MultiSelectFilter} from './multi-select-filter';

export class InverseMultiSelectFilter extends MultiSelectFilter {

  internalPassesFilter(dataFromDataRow): boolean {
    if (this.isBlankOverride !== false) {
      //By default when this thing is in a filter container we want it to return that it is blank.
      //This makes it so this is essentially a no-op during the filterTask. The InverseMultiSelectFilterTask will
      //set isBlankOverride so that the passesFilter function will run internalPassesFilter.
      return true;
    }

    let allCheckBoxLabels: Array<string> = Object.keys(this.searchValues);
    let matches = allCheckBoxLabels.find((checkboxLabel) => {
      let shouldMatch = !this.searchValues[checkboxLabel];
      if (shouldMatch) {
        //Retrieve underlying data for the checkbox label
        let selectedOption = (<SelectField>this.dataField).selectOptions.get(checkboxLabel);

        //Leave in this console.log commented out. It's REALLY nice for debugging.
        //console.log('Comparing: ' + dataFromDataRow + ' to ' + selectedOption);
        if (typeof selectedOption === 'function') {
          //NOTE: DataFromDataRow is just a piece of data from a dataRow object.
          //If you need the full DataRow passed in, add a property to each dataRow called self
          //and point it at its self.  Then when 'self' is extracted, the full data row will be passed into
          //the selectOption function.

          //Example
          // for (let student of students) {
          //   //self now points at the entire student.
          //   student.self = student;
          // }
          return selectedOption(dataFromDataRow) === true;
        } else if (typeof dataFromDataRow === 'string' && typeof selectedOption === 'string') {
          return dataFromDataRow.toUpperCase() === selectedOption.toUpperCase();
        } else {
          return dataFromDataRow === selectedOption;
        }
      }
      return false;
    });
    return matches == null;
  }
}
